export default __webpack_public_path__ + "static/media/080-sheep.c771d3db.svg";